import getLastUrlFragment from './get-last-url-fragment';
/**
 * Find a leaf category from the a category node by slug
 * @param { Object } category - category possibly containing the children leafs
 * @param {string} leafCategorySlug - leaf category slug to find
 * @return {Object|undefined}
 */
export default function findLeafBySlug(category, leafCategorySlug) {
    return category.children.find(c => getLastUrlFragment(c.slug) === leafCategorySlug);
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/find-leaf-category-by-slug.js